import {IUpdateStatusModalAction} from '../models/IModalBurger'


export const updateStatusModalBurger = (
    status:boolean
):IUpdateStatusModalAction =>({
    type:'UPDATE_STATUS_MODAL',
    status:status
})
